import React, { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const FluentMail: FC<{ fillColor?: string } & SvgProps> = ({
  fillColor = '#212121',
  ...props
}) => (
  <Svg
    width={24}
    height={24}
    fill='none'
    viewBox='0 0 24 24'
    {...props}
  >
    <Path
      d='M5.25 4h13.5a3.25 3.25 0 013.245 3.066L22 7.25v9.5a3.25 3.25 0 01-3.066 3.245L18.75 20H5.25a3.25 3.25 0 01-3.245-3.066L2 16.75v-9.5a3.25 3.25 0 013.066-3.245L5.25 4h13.5-13.5zM20.5 9.373l-8.15 4.29a.75.75 0 01-.603.043l-.096-.042L3.5 9.374v7.376a1.75 1.75 0 001.606 1.744l.144.006h13.5a1.75 1.75 0 001.744-1.607l.006-.143V9.373zM18.75 5.5H5.25a1.75 1.75 0 00-1.744 1.606L3.5 7.25v.429l8.5 4.473 8.5-4.474V7.25a1.75 1.75 0 00-1.607-1.744L18.75 5.5z'
      fill={fillColor}
    />
  </Svg>
)
export default FluentMail
